import { Component } from "@angular/core";
import { MatTabsModule } from "@angular/material/tabs";
import { EmailOutreachPanelComponent } from "./email-outreach-panel/email-outreach-panel.component";
import { SgTelegramPanelComponent } from "./sg-telegram-panel/sg-telegram-panel.component";

/**
 * Consumer Outreach: the channels FishyHub pushes to shoppers through, as
 * opposed to the ones shoppers come to - one tab each: Telegram (products to
 * the SG channel) and Email (segment emails, one per user).
 */
@Component({
  selector: "fh-consumer-outreach",
  templateUrl: "./consumer-outreach.component.html",
  standalone: true,
  imports: [MatTabsModule, SgTelegramPanelComponent, EmailOutreachPanelComponent],
})
export class ConsumerOutreachComponent {}
